module.exports = __webpack_public_path__ + "static/img/card_1.88285e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/survery/card_1.png
// module id = QxYO
// module chunks = 1